import styled from 'styled-components'
import { Button } from '../../components/common/Button'

export const LegalDeclarationButton = styled(Button)`
  width: 100%;
`
